package org.multipaz.storage

sealed class StorageException(message: String): Exception(message)